export const STYLE_MAP = {
  default: {
    textColor: '#8E969B'
  },
  colmo: {
    textColor: '#1E2E37'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-catalog/style.js